var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 19.7967C1 16.9814 3.18227 14.5834 6.14805 14.1398L6.4152 14.0998C8.79004 13.7445 11.21 13.7445 13.5848 14.0998L13.8519 14.1398C16.8177 14.5834 19 16.9814 19 19.7967C19 21.0136 17.9477 22 16.6495 22H3.35045C2.05233 22 1 21.0136 1 19.7967Z",
    stroke: "url(#paint0_linear_766_3280)",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 5.59375C15.25 8.13081 12.8995 10.1875 10 10.1875C7.10053 10.1875 4.75003 8.13081 4.75003 5.59375C4.75003 3.05669 7.10053 1 10 1C12.8995 1 15.25 3.05669 15.25 5.59375Z",
    stroke: "url(#paint1_linear_766_3280)",
    strokeWidth: 1.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_766_3280",
    x1: 10,
    y1: 1,
    x2: 10,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D64242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#982020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_766_3280",
    x1: 10,
    y1: 1,
    x2: 10,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D64242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#982020"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.78b11e8e5a7437d2d833b6426803d038.svg";
export { ForwardRef as ReactComponent };